import { Column } from '@tanstack/react-table';
import TextFilter from '@components/primitives/dataGrid/components/filters/TextFilter';
import DateRangeFilter from '@components/primitives/dataGrid/components/filters/DateRangeFilter';
import NumericFilter from '@components/primitives/dataGrid/components/filters/NumericFilter';
import SelectFilter from '@components/primitives/dataGrid/components/filters/SelectFilter';

interface Props<TData> {
    column: Column<TData>;
}
const Filter = <TData extends object>({ column }: Props<TData>) => {
    const { filterFn } = column.columnDef;

    if (filterFn === 'dateRange') {
        return <DateRangeFilter column={column} />;
    }

    if (filterFn === 'numeric') {
        return <NumericFilter column={column} />;
    }

    if (filterFn === 'select') {
        return <SelectFilter column={column} />;
    }

    return <TextFilter column={column} />;
};

export default Filter;
